import { Injectable } from '@angular/core';

export type B2BFeatureFlags = 'SSO';

interface BugsnagStartConfig {
  apiKey: string;
  releaseStage?: string;
  appVersion?: string;
}

export interface BugsnagEvent {
  context: string;
  addMetadata(section: string, values: object): void;
  addMetadata(section: string, key: string, value: unknown): void;
  [key: string]: unknown;
}

interface BugsnagStatic {
  start(config: BugsnagStartConfig): void;
  notify(error: unknown, onError?: (event: BugsnagEvent) => void): void;
  addFeatureFlag(name: string, variant?: string | null): void;
  clearFeatureFlag(name: string): void;
}

interface BugsnagWindow {
  Bugsnag?: BugsnagStatic;
  CONFIG?: { bugsnag?: { key?: string }; environment?: string };
  VERSION?: string;
}

@Injectable({ providedIn: 'root' })
export class BugsnagService {
  private get instance(): BugsnagStatic {
    return (window as unknown as BugsnagWindow).Bugsnag as BugsnagStatic;
  }

  notify: BugsnagStatic['notify'] = (...args) => this.instance.notify(...args);

  start(): void {
    const w = window as unknown as BugsnagWindow;
    if (this.instance && w.CONFIG?.bugsnag?.key) {
      this.instance.start({
        apiKey: w.CONFIG.bugsnag.key,
        releaseStage: w.CONFIG.environment,
        appVersion: w.VERSION,
      });
    }
  }

  addFeatureFlag(name: B2BFeatureFlags, variant?: string | null): void {
    this.instance.addFeatureFlag(name, variant);
  }

  clearFeatureFlag(name: B2BFeatureFlags): void {
    this.instance.clearFeatureFlag(name);
  }
}
